/* eslint-disable anti-slop/require-safety-comment-for-type-assertion, anti-slop/no-object-parameters, anti-slop/no-known-value-widening -- verbatim restore of the pre-FA-3036 data dashboard, served while data_dashboard_v2_enabled is off */
import { FBoxContainer, FHSimpleTable } from '../../base';
import {
  durationTrialAverageColumnNames,
  phaseChangeColumnNames,
  trialAverageColumnNames,
} from './constants';
import { TPGoalDataCollectionMethod } from '../treatment-plan/goals/common/constants/general';
import { capitalizeFirstLetter } from '../../../helpers';

import type { IDurationTrialAverageTableData, ITrialAverageTableData } from '../../../utils/types';

interface ITargetPhaseChangeTableProps {
  dcm?: string;
  durationUnit: string;
  rateUnit: string;
  hidePhaseChange?: boolean;
  tableData: string[][];
  tableColumnNames: string[];
  phaseChangeTableData: { [key: string]: string }[];
  trialAverageTableData: ITrialAverageTableData[];
  durationTrialAverageTableData: IDurationTrialAverageTableData[];
  selectedTargetsCount?: number;
}

function TargetPhaseChangeTableLegacy({
  dcm,
  durationUnit,
  rateUnit,
  hidePhaseChange = false,
  tableData = [],
  tableColumnNames = [],
  phaseChangeTableData = [],
  trialAverageTableData = [],
  durationTrialAverageTableData = [],
  selectedTargetsCount = 0,
}: ITargetPhaseChangeTableProps) {
  const isSingleTarget = selectedTargetsCount === 1;

  return (
    <>
      {/* Only show Chart Data and Phase Change Data for single target */}
      {isSingleTarget && (
        <>
          <FBoxContainer
            dataTestId="chartData"
            sx={{ textAlign: 'left', borderRadius: '10px', boxShadow: 'none', mt: -1 }}
          >
            <FHSimpleTable
              title={`${capitalizeFirstLetter(dcm?.toLowerCase() ?? '')} ${
                dcm === TPGoalDataCollectionMethod.DURATION
                  ? `(in ${durationUnit}s)`
                  : dcm === TPGoalDataCollectionMethod.RATE
                    ? `(per ${rateUnit?.substring(0, rateUnit.length - 1)})`
                    : ''
              }`}
              data={tableData}
              columnDefinitions={tableColumnNames}
              columnOptions={{
                filter: false,
                print: false,
                search: false,
                viewColumns: false,
                selectableRows: 'none',
                tableBodyMaxHeight: '700px',
                pagination: false,
                download: false,
                responsive: 'standard',
                fixedHeader: false,
                sort: false,
              }}
            />
          </FBoxContainer>
          {phaseChangeTableData?.length > 0 && !hidePhaseChange && (
            <FBoxContainer
              sx={{ mt: 2, textAlign: 'left', borderRadius: '10px', boxShadow: 'none' }}
            >
              <FHSimpleTable
                title={'Phase Change Data'}
                data={phaseChangeTableData}
                columnDefinitions={phaseChangeColumnNames}
                columnOptions={{
                  filter: false,
                  print: false,
                  search: false,
                  viewColumns: false,
                  selectableRows: 'none',
                  tableBodyMaxHeight: '700px',
                  pagination: false,
                  download: false,
                  responsive: 'standard',
                  fixedHeader: false,
                  sort: false,
                }}
              />
            </FBoxContainer>
          )}
        </>
      )}

      {/* Show Average table for any number of targets */}
      {trialAverageTableData?.length > 0 &&
      !hidePhaseChange &&
      dcm === TPGoalDataCollectionMethod.DURATION ? (
        <FBoxContainer
          sx={{
            mt: isSingleTarget ? 2 : 0,
            textAlign: 'left',
            borderRadius: '10px',
            boxShadow: 'none',
          }}
        >
          <FHSimpleTable
            title={`Target summary (in ${durationUnit}s)`}
            data={durationTrialAverageTableData.map((row) => ({
              target: row.target,
              label: row.label,
              average: row.average,
              total: row.total,
            }))}
            columnDefinitions={durationTrialAverageColumnNames}
            columnOptions={{
              filter: false,
              print: false,
              search: false,
              viewColumns: false,
              selectableRows: 'none',
              tableBodyMaxHeight: '700px',
              pagination: false,
              download: false,
              responsive: 'standard',
              fixedHeader: false,
              sort: false,
            }}
          />
        </FBoxContainer>
      ) : (
        <FBoxContainer
          sx={{
            mt: isSingleTarget ? 2 : 0,
            textAlign: 'left',
            borderRadius: '10px',
            boxShadow: 'none',
          }}
        >
          <FHSimpleTable
            title={`Target summary (${capitalizeFirstLetter(dcm?.toLowerCase() ?? '')}${
              dcm === TPGoalDataCollectionMethod.DURATION
                ? ` in ${durationUnit}s`
                : dcm === TPGoalDataCollectionMethod.RATE
                  ? ` per ${rateUnit?.substring(0, rateUnit.length - 1)}`
                  : ''
            })`}
            data={trialAverageTableData.map((row) => ({
              target: row.target,
              label: row.label,
              value: `${row.value}${row.unit === '%' ? '' : ' '}${row.unit}`,
            }))}
            columnDefinitions={trialAverageColumnNames}
            columnOptions={{
              filter: false,
              print: false,
              search: false,
              viewColumns: false,
              selectableRows: 'none',
              tableBodyMaxHeight: '700px',
              pagination: false,
              download: false,
              responsive: 'standard',
              fixedHeader: false,
              sort: false,
            }}
          />
        </FBoxContainer>
      )}
    </>
  );
}

export default TargetPhaseChangeTableLegacy;
